<template>
  <div class="modal" :class="[$realmNameId==50?'modal-50':'']">
    <div class="modal-cover"></div>
    <!--<div :class="['modalOff','modalOff'+(state==2&&modalOff==3?'4':modalOff)]"></div>-->
    <div :class="['modalOff','modalOff'+modalClass]" :style="(leftCss)"></div>
    <template v-if="modalOff==0">
      <div class="icon-guide" :class="['icon-guide'+modalClass]">
        <span class="icon-guide icon-know" :class="['icon-know'+modalClass]" @click="startStep"></span>
        <span class="icon-guide icon-know icon-bye" @click="closeTips"></span>
      </div>
    </template>
    <template v-else>
      <div class="icon-guide" :class="['icon-guide'+modalClass]" :style="leftCss">
        <span class="icon-guide icon-know" :class="['icon-know'+modalClass]" @click="nextStep"></span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['state', 'client'], // 0:home/index.vue  1:searchPage/index.vue  2:city/index.vue 3:map/index.vue
  name: 'Modal',
  data () {
    return {
      n: 4,
      modalOff: 0,
      modalOffAll: 4,
      modalClass: 0,
      leftCss: {}
    }
  },
  created () {
    $('body,html').animate({scrollTop: 0}, 500)
    this.n = this.state === 2 ? 3 : 4
    this.modalOffAll = this.n
  },
  mounted () {
  },
  components: {},
  methods: {
    startStep: function () {
      this.stateFun()
    },
    stateFun: function () {
      let that = this
      if (that.state === 1) {
      } else if (that.state === 2) {
        let stateBool0 = that.publicJs.getCookie(0)
        if (!stateBool0) {
          that.modalOff = 1
          this.modalClass = that.modalOff
        } else {
          that.modalOff = this.n
          that.modalClass = '2-' + this.n
        }
      } else if (that.state === 3) {

      } else {
        that.modalOff = 1
        that.modalOffAll = this.n
        this.modalClass = that.modalOff
      }
    },
    nextStep: function () {
      let that = this
      if (that.modalOff < that.modalOffAll) {
        that.modalOff++
        that.modalClass = that.state > 0 && that.modalOff === this.n ? that.state + '-' + that.modalOff : that.modalOff
        if (that.state === 0 && that.modalOff === 4) {
          $('.app-content').animate({scrollTop: 180}, 500)
        } else {
          $('.app-content').animate({scrollTop: 0}, 500)
        }
      } else {
        that.$emit('modalBool', false)
        that.publicJs.setCookie(0, 'true', 60)
      }
    },
    closeTips: function () {
      this.$emit('modalBool', false)
      this.publicJs.setCookie(0, 'true', 60)
    }
  },
  watch: {
    modalClass: {
      handler: function (a, b) {
        if (a !== b) {
          let that = this
          if (a === 3) {
            let el = $('.slide-address2')
            let l = el.offset().left
            that.leftCss.left = (l - 5) + 'px'
          } else if (a === 4) {
            let el1 = $('.industry-map')
            let l1 = el1.offset().left
            let t1 = el1.offset().top
            that.leftCss = {
              left: (l1) + 'px',
              top: (t1 - 185) + 'px'
            }
          } else {
            that.leftCss = {}
          }
        }
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .modal{}
  .modal-cover{
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
  .modalOff{
    position: absolute;
    -webkit-box-shadow: rgba(0,0,0,0.7) 0px 0px 0px 5000px;
    -moz-box-shadow: rgba(0,0,0,0.7) 0px 0px 0px 5000px;
    box-shadow: rgba(0,0,0,0.7) 0px 0px 0px 5000px;
    z-index: 110;
  }
  .modalOff0{
    position: absolute;
    right: 50%;
    top: 50%;
    width: 0;
    height:0;
  }
  .modalOff1{
    right: 11px;
    left: 10px;
    top: 55px;
    width: 310px;
    height: 23px;
    border-radius: 5px;
  }
  .modalOff2{
    position: fixed;
    right: 11px;
    top: 72px;
    width: 33px;
    height: 33px;
    border-radius: 50%;
  }
  .modalOff3{
    left: 62%;
    top: 358px;
    width: 89px;
    height: 40px;
    border: 1px solid #FFFFFF;
    border-radius: 10px;
  }
  .modalOff4{
    left: 62%;
    top: 30%;
    width: 36px;
    height: 36px;
    border: 1px solid #FFFFFF;
    border-radius: 10px;
    margin-left: 0px;
    margin-top: 6px;
  }
  .modalOff2-3{
    position: fixed;
    right: 22px;
    top: 2px;
    width: 71px;
    height: 36px;
    border-radius: 5px;
  }
  .modal-four{
    position: absolute;
  }

  .icon-guide{
    position: absolute;
    z-index: 111;
  }
  .modalOff0,
  .modalOff1,
  .modalOff2,
  .modalOff2-3,
  .modal .icon-guide1,
  .modal .icon-guide2,
  .modal .icon-guide2-3{
    -webkit-transition: right 0.8s,top 0.8s;
    -moz-transition: right 0.8s,top 0.8s;
    -ms-transition: right 0.8s,top 0.8s;
    -o-transition: right 0.8s,top 0.8s;
    transition: right 0.8s,top 0.8s;
  }

  .modalOff3,
  .modal .icon-guide3{
    -webkit-transition: width 0.8s,top 0.8s;
    -moz-transition: width 0.8s,top 0.8s;
    -ms-transition: width 0.8s,top 0.8s;
    -o-transition: width 0.8s,top 0.8s;
    transition: width 0.8s,top 0.8s;
  }

  .icon-guide0{
    position: fixed;
    top:50%;
    right: 50%;
    width: 260px;
    height: 254px;
    margin-top: -160px;
    margin-right: -127px;
    background-position: -87px -1092px;
  }
  .icon-guide1{
    width: 320px;
    height: 93px;
    top: 48px;
    right: 11px;
    left: 5px;
    background-position: -45px -16px;
    background-size: 450px;
  }
  .icon-guide2{
    position: fixed;
    top: 51px;
    right: 3px;
    width: 239px;
    height: 225px;
    background-position: -124px -794px;
  }
  .icon-guide3{
    width: 218px;
    height: 158px;
    top: 359px;
    right: 50px;
    background-position: -100px -134px;
    margin-left: -125px;
  }
  .icon-guide4{
    width: 233px;
    height: 190px;
    top: 300px;
    right: 50px;
    left: 5.5%;
    background-position:-118px -310px;
    margin-left: -95px;
    margin-top: -2px;
  }

  .icon-guide2-3{
    top: 4px;
    right: 22px;
    width: 274px;
    height: 175px;
    background-position: -84px -548px;
    position: fixed;
  }
  .icon-know{
    width: 76px;
    height: 33px;
    background-position: -346px -1408px;
  }
  .icon-bye{
    right:39px;
    bottom: -50px;
    background-position: -227px -1408px;
  }
  .icon-know0{
    right:152px;
    bottom: -50px;
    background-position: -114px -1408px;
  }
  .icon-know1{
    top: 110px;
    right: auto;
    left: 105px;
  }
  .icon-know2{
    right:110px;
    bottom: -51px;
  }
  .icon-know3{
    top: 165px;
    right: 69px;
  }
  .icon-know4{
    top: 203px;
    right: 88px;
  }
  .icon-know2-3{
    right: 122px;
    bottom: -16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Phone/Modal.vue